interface SubscriptionBroadcastMessage {
    type: 'SUBSCRIPTION_UPDATED';
    success: boolean;
}

export const useSubscriptionBroadcast = () => {
    const channel = useBroadcastChannel<SubscriptionBroadcastMessage>('subscription-update');

    /** 다른 탭에 구독 갱신 이벤트 전송 (fire-and-forget) */
    const notifySubscriptionUpdate = (success = true): void =>
        channel.postOnce({ type: 'SUBSCRIPTION_UPDATED', success });

    /** 다른 탭에서 보낸 구독 갱신 이벤트 수신. onBeforeUnmount 시 자동 정리. */
    const onSubscriptionUpdate = (callback: (success: boolean) => void): void => {
        const unsubscribe = channel.subscribe((data) => {
            if (data?.type === 'SUBSCRIPTION_UPDATED') callback(data.success);
        });
        onBeforeUnmount(unsubscribe);
    };

    return { notifySubscriptionUpdate, onSubscriptionUpdate };
};
